import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '../context/BrandingContext';
import './WifiBanner.css';

function WifiBanner() {
  const { t } = useTranslation();
  const { wifi } = useBranding();
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);

  if (!wifi?.network) return null;

  const isAndroid = /android/i.test(navigator.userAgent);

  const handleCopyPassword = async () => {
    if (!wifi.password) return;
    try {
      await navigator.clipboard.writeText(wifi.password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const input = document.createElement('input');
      input.value = wifi.password;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleOpenWifiSettings = () => {
    window.location.href = 'intent://#Intent;action=android.settings.WIFI_SETTINGS;end';
  };

  return (
    <div className="wifi-banner" onClick={() => setExpanded(!expanded)}>
      <div className="wifi-banner__header">
        <span className="material-icons wifi-banner__icon" aria-hidden="true">wifi</span>
        <span className="wifi-banner__label">
          {t('wifi.available', 'WiFi disponible')}
        </span>
        <span className="wifi-banner__network">{wifi.network}</span>
        <span className="material-icons wifi-banner__chevron" aria-hidden="true">
          {expanded ? 'expand_less' : 'expand_more'}
        </span>
      </div>

      {expanded && (
        <div className="wifi-banner__details" onClick={(e) => e.stopPropagation()}>
          <div className="wifi-banner__row">
            <span className="wifi-banner__key">{t('wifi.network', 'Red')}</span>
            <span className="wifi-banner__value">{wifi.network}</span>
          </div>
          {wifi.password && (
            <div className="wifi-banner__row">
              <span className="wifi-banner__key">{t('wifi.password', 'Contraseña')}</span>
              <span className="wifi-banner__value wifi-banner__password">{wifi.password}</span>
              <button
                className="wifi-banner__copy-btn"
                onClick={handleCopyPassword}
              >
                <span className="material-icons" aria-hidden="true">
                  {copied ? 'check' : 'content_copy'}
                </span>
              </button>
            </div>
          )}
          {isAndroid && (
            <button className="wifi-banner__connect-btn" onClick={handleOpenWifiSettings}>
              <span className="material-icons" aria-hidden="true">settings</span>
              {t('wifi.openSettings', 'Abrir config. WiFi')}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default WifiBanner;
